import styled from '@emotion/styled';
import { truncateText } from '@tokens';

/**
 * NotificationLabel component.
 *
 * **WARNING!** _This component is for internal use in the Design System. If you
 * need to use it for a custom component, please discuss your use case with
 * the Design System squad before proceeding, as they may be able to help
 * you with a better solution._
 * @summary Provides a label for notification components.
 * @private
 */
export const NotificationLabel = styled.span`
  ${truncateText()}
`;
